import axiosClient from "../../../shared/lib/axiosClient";
import { USER_API_BASE } from "../../../shared/utils/apiConfig";
import type { PracticeRequest, PracticeResult, PracticeStartResponse } from "../projectTypes";

type Id = number | string;
type PracticeKind = PracticeRequest["kind"];

// Each kind of project runs on its own route. The sql one is an ASSUMPTION: see the questions below.
const PRACTICE_PATH: Record<PracticeKind, string> = {
    program: "practice",
    web: "practice-web",
    sql: "practice-sql"
};

// Step 1: queue the learner's work for checking
export const startPractice = async (
    userId: Id,
    request: PracticeRequest,
    signal?: AbortSignal
): Promise<PracticeStartResponse> => {
    const { kind, ...body } = request; // "kind" only picks the route: the server doesn't read it
    const { data } = await axiosClient.post<PracticeStartResponse>(
        `${USER_API_BASE}/${userId}/${PRACTICE_PATH[kind]}`,
        body,
        { signal }
    );
    return data;
};

// Step 2: ask how the job is doing
export const getPracticeResult = async (
    userId: Id,
    kind: PracticeKind,
    jobId: string,
    signal?: AbortSignal
): Promise<PracticeResult> => {
    const { data } = await axiosClient.get<PracticeResult>(
        `${USER_API_BASE}/${userId}/${PRACTICE_PATH[kind]}/${jobId}`,
        { signal }
    );
    return data;
};